import { bondingCurveMarketCapFromQuoteReserveD6 } from '@morfi/market-math';

/** Wire/runtime adapter; executable bonding-curve math is owned by market-math. */
export function effectiveMcapD6(poolD6: bigint, virtualD6: bigint): bigint | null {
  const result = bondingCurveMarketCapFromQuoteReserveD6({
    poolQuoteReserveD6: poolD6,
    virtualQuoteReserveD6: virtualD6,
  });
  return result.available ? result.value : null;
}
